module.exports = __webpack_public_path__ + "static/media/zajednica.a589f4bb.svg";